import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { OverlayPanel } from 'primeng/overlaypanel';
import { CourseDto } from 'src/app/aplication/api/Manipulate/CoursesObjects/CourseDto';
import { CourseModuleCreateDto, CourseModuleDto } from 'src/app/aplication/api/Manipulate/CoursesObjects/CourseModuleDto';
import { TeacherDto } from 'src/app/aplication/api/Manipulate/CoursesObjects/TeacherDto';
import { CourseService } from 'src/app/aplication/api/Services/CourseServices/Course.service';
import { CourseModuleService } from 'src/app/aplication/api/Services/CourseServices/CourseModule.service';
import { UploadService } from 'src/app/aplication/api/Services/UploadService/Upload.service';

@Component({
  selector: 'app-course-details',
  templateUrl: './course-details.component.html',
  styleUrl: './course-details.component.scss'
})
export class CourseDetailsComponent implements OnInit {
  @ViewChild('createModule') createModule!: OverlayPanel;
  @ViewChild('buttonFileUpload') buttonFileUpload!: FileUpload;

  // LISTS
  clonedCourse: { [key: string]: CourseDto } = {};
  isPublicOptions: { label: string; value: boolean }[] = [
    { label: 'Sim', value: true },
    { label: 'Não', value: false }
  ];

  // CONTROLE
  addingModule: boolean = false;
  showDialogModuleDetails: boolean = false;
  uploadingThumb: boolean = false;

  // DECLARAÇÕES
  layout: 'list' | 'grid' = 'grid';
  newModule: CourseModuleCreateDto = new CourseModuleCreateDto();
  selectedModule: CourseModuleDto | null = null;

  // Validação
  editingCourse: CourseDto | null = null;

  // PROPS
  private _selectedCourse!: CourseDto;
  public get selectedCourse(): CourseDto {
    return this._selectedCourse;
  }
  @Input() public set selectedCourse(v: CourseDto) {
    this._selectedCourse = v;
    if (v) {
      v.courseModules = v.courseModules.sort((a, b) => a.order - b.order);
    }
  }

  private _listTeachers: TeacherDto[] = [];
  public get listTeachers(): TeacherDto[] {
    return this._listTeachers;
  }
  @Input() public set listTeachers(v: TeacherDto[]) {
    this._listTeachers = v;
  }

  constructor(
    protected messageService: MessageService,
    protected _courseService: CourseService,
    protected _confirmationService: ConfirmationService,
    protected _moduleService: CourseModuleService,
    private _uploadService: UploadService
  ) {}

  ngOnInit(): void {}

  openFileInput(): void {
    window.open(this.selectedCourse.thumbnailUrl, '_blank');
  }

  GetCourseModules(): void {
    this.showDialogModuleDetails = false;
    this._moduleService.ListModuleByCourse(this.selectedCourse.id).subscribe({
      next: (response) => {
        this.selectedCourse.courseModules = response.sort((a: any, b: any) => a.order - b.order);
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao carregar módulos'
        });
      }
    });
  }

  onRowEditInit(course: CourseDto): void {
    this.clonedCourse[course.id as string] = { ...course };
    this.editingCourse = { ...course };
  }

  onRowEditSave(course: CourseDto): void {
    // Upload thumbnail se necessário
    if (this.buttonFileUpload?.files?.length) {
      this.uploadThumbnailWithService(course);
    }

    if (this.editingCourse && this.editingCourse.price >= 0) {
      const dto = new CourseDto();
      dto.id = this.selectedCourse.id;
      dto.title = this.editingCourse.title;
      dto.price = this.editingCourse.price;
      dto.description = this.editingCourse.description;
      dto.teacherId = this.editingCourse.teacherId;
      dto.isPublic = this.editingCourse.isPublic;

      this._courseService.EditCourse(dto).subscribe({
        next: () => {
          // Atualiza o curso selecionado com os novos valores
          Object.assign(this.selectedCourse, dto);
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Curso atualizado com sucesso!'
          });
        },
        error: (error) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: this.extractErrorMessage(error)
          });
        }
      });
    }

    delete this.clonedCourse[course.id as string];
    this.editingCourse = null;
  }

  ChangePublishedState(): void {
    const dto = { ...this.selectedCourse };
    dto.isPublished = !this.selectedCourse.isPublished;

    this._courseService.EditCourse(dto).subscribe({
      next: () => {
        this.selectedCourse.isPublished = dto.isPublished;
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: `Curso ${dto.isPublished ? 'publicado' : 'despublicado'}`
        });
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao atualizar status'
        });
      }
    });
  }

  onRowEditCancel(course: CourseDto, index: number): void {
    this.selectedCourse = this.clonedCourse[course.id as string];
    delete this.clonedCourse[course.id as string];
    this.editingCourse = null;
  }

  // GETTERS PARA EDIÇÃO
  get editTitle(): string {
    return this.editingCourse?.title ?? this.selectedCourse.title;
  }

  set editTitle(value: string) {
    if (this.editingCourse) this.editingCourse.title = value;
  }

  get editPrice(): number {
    return this.editingCourse?.price ?? this.selectedCourse.price;
  }

  set editPrice(value: number) {
    if (this.editingCourse) this.editingCourse.price = value;
  }

  get editDescription(): string {
    return this.editingCourse?.description ?? this.selectedCourse.description;
  }

  set editDescription(value: string) {
    if (this.editingCourse) this.editingCourse.description = value;
  }

  get editTeacherId(): string {
    return this.editingCourse?.teacherId ?? this.selectedCourse.teacherId;
  }

  set editTeacherId(value: string) {
    if (this.editingCourse) this.editingCourse.teacherId = value;
  }

  get editIsPublic(): boolean {
    return this.editingCourse?.isPublic ?? this.selectedCourse?.isPublic ?? false;
  }

  set editIsPublic(value: boolean) {
    if (this.editingCourse) this.editingCourse.isPublic = value;
  }

  AddModule(event: any): void {
    if (!this.newModule.title?.trim()) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Informe o título do módulo',
        life: 2000
      });
      return;
    }

    this.addingModule = true;
    this.newModule.courseId = this.selectedCourse.id;

    this._moduleService.AddModule(this.newModule).subscribe({
      next: (response) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Módulo criado com sucesso!'
        });
        this.addingModule = false;
        this.selectedCourse.courseModules.push(response);
        this.createModule.hide();
        this.resetNewModule();
      },
      error: () => {
        this.addingModule = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao criar módulo'
        });
      }
    });
  }

  private resetNewModule(): void {
    this.newModule = new CourseModuleCreateDto();
  }

  ConfirmDeleteModule(event: any, module: CourseModuleDto): void {
    this._confirmationService.confirm({
      target: event.target as EventTarget,
      header: 'Confirmar exclusão',
      message: 'Tem certeza que deseja excluir este módulo?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this._moduleService.Delete(module.id!).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: 'Módulo excluído'
            });
            this.selectedCourse.courseModules = this.selectedCourse.courseModules.filter(
              x => x.id !== module.id
            );
          },
          error: () => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Erro ao excluir módulo'
            });
          }
        });
      }
    });
  }

  ShowDialogModuleDetails(module: CourseModuleDto): void {
    this.selectedModule = module;
    this.showDialogModuleDetails = true;
  }

  onFileSelectByHeader(event: any): void {
    // Validação de arquivo
    const files: File[] = event.currentFiles;
    if (files.length === 0) return;

    const file = files[0];
    const validation = this._uploadService.validateFile(file, {
      maxSizeMB: 15,
      allowedTypes: ['image/png', 'image/jpeg', 'image/jpg', 'image/webp']
    });

    if (!validation.valid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: validation.error,
        life: 4000
      });
      return;
    }
  }

  CancelArchive(): void {
    if (this.buttonFileUpload) {
      this.buttonFileUpload.clear();
    }
  }

  onImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = '../../../../../../../assets/defaultImage.png';
  }

  /**
   * Upload usando o serviço centralizado
   */
  uploadThumbnailWithService(course: CourseDto): void {
    const file = this.buttonFileUpload?.files?.[0];
    if (!file) return;

    this.uploadingThumb = true;

    this._uploadService.uploadCourseThumbnail(course.id, file).subscribe({
      next: (result) => {
        this.uploadingThumb = false;
        if (result.success) {
          this.selectedCourse.thumbnailUrl = result.url;
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Thumbnail atualizado!'
          });
          this.CancelArchive();
        }
      },
      error: (error) => {
        this.uploadingThumb = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: this.extractErrorMessage(error)
        });
      }
    });
  }

  OpenThumbnail(course: CourseDto): void {
    window.open(course.thumbnailUrl, '_blank');
  }

  private extractErrorMessage(error: any): string {
    if (error.error?.message) {
      return error.error.message;
    }
    return 'Erro na operação. Tente novamente.';
  }
}
